import { useState } from "react";
import { FORMATION } from "@/content/research";
import { ExplorerFrame, Swap } from "@/components/site/ExplorerFrame";
import { Mono } from "@/components/site/primitives";
import { StageRail, StageStepper } from "./StageRail";

const IDS = FORMATION.map((f) => f.id);

const Detail = ({ f }) => (
  <div className="grid md:grid-cols-12" data-testid="formation-detail">
    <div className="border-b border-o-line p-5 sm:p-7 md:col-span-6 md:border-b-0 md:border-r">
      <Mono accent>{f.label} · what happens</Mono>
      <p className="mt-3 font-display text-xl font-bold leading-snug sm:text-2xl">{f.happens}</p>
    </div>
    <dl className="grid md:col-span-6">
      <div className="border-b border-o-line p-5 sm:p-7">
        <dt><Mono>Begins from</Mono></dt>
        <dd className="mt-2 leading-relaxed">{f.from}</dd>
      </div>
      <div className="p-5 sm:p-7">
        <dt><Mono>Leaves behind</Mono></dt>
        <dd className="mt-2 leading-relaxed">{f.leaves}</dd>
      </div>
    </dl>
  </div>
);

const FormationText = () => (
  <ol className="divide-y divide-o-line" data-testid="formation-text">
    {FORMATION.map((f) => (
      <li key={f.id} className="grid gap-3 p-5 sm:p-7 md:grid-cols-12">
        <div className="md:col-span-3"><Mono accent>{f.index}</Mono><h3 className="mt-1 font-display text-xl font-bold">{f.label}</h3></div>
        <div className="space-y-2 text-sm md:col-span-9">
          <p className="text-base">{f.happens}</p>
          <p className="text-o-dim">Begins from: {f.from}</p>
          <p className="text-o-dim">Leaves behind: {f.leaves}</p>
        </div>
      </li>
    ))}
  </ol>
);

export const FormationExplorer = () => {
  const [sel, setSel] = useState("research");
  const [mode, setMode] = useState("explore");
  return (
    <ExplorerFrame
      testid="formation-explorer"
      label="Product formation"
      hint="Each product begins with a human activity, not a technology. Select a stage of formation."
      mode={mode}
      onMode={setMode}
    >
      {mode === "explore" ? (
        <>
          <StageRail stages={FORMATION} sel={sel} onSelect={setSel} testid="formation" loopLabel="Learning returns to research and to the shared foundation" />
          <div aria-live="polite">
            <Swap k={sel}><Detail f={FORMATION[IDS.indexOf(sel)]} /></Swap>
          </div>
          <StageStepper ids={IDS} sel={sel} onSelect={setSel} testid="formation" />
        </>
      ) : (
        <FormationText />
      )}
    </ExplorerFrame>
  );
};
